import { render } from "./RenderAssetsByPrescription.vue?vue&type=template&id=16f08887"
import script from "./RenderAssetsByPrescription.vue?vue&type=script&lang=js"
export * from "./RenderAssetsByPrescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__